<template>
  <div>
    <Component50 />
    <Component52 />
    <Component53 />
  </div>
</template>
<script>
import Component50 from '@/v2/auto/sections/50-zhi.vue'
import Component52 from '@/v2/auto/sections/52-map.vue'
import Component53 from '@/v2/auto/sections/53-ai.vue'
export default {
  components: {
    Component50,
    Component52,
    Component53,
  },
}
</script>
